<template lang="pug">

v-card
  .weekday-name
    span {{ weekDayName }}
    span(v-if="isToday") (сегодня)
    span.mx-1 -
    span {{ currentDate.format('DD.MM.YYYY') }}

  table.table-lessons
    thead
      tr
        th.time #
        th.caption-lessons Занятия

    tbody
      tr(v-if="!hasLessons")
        td(style="border-right: 0")
        td Нет занятий

      template(v-else)
        template(v-for="row, i in times")
          template(v-if="i > 0 && isTeachers && hasWindow(times[i - 1], times[i])")
            tr.window
              td.time
              td {{ windowDuration(times[i - 1], times[i]) }}

          tr(:class="{ 'current-time': hasCurrentTime(row) }")
            td.time
              div {{ row.startTime }}
              div {{ row.endTime }}

            row-lessons(:lessons="row.lessons" :is-teachers="isTeachers" :is-cabinets="isCabinets")


</template>

<script>
import { mapGetters } from 'vuex'
import rowLessons from './rowLessons'
import moment from 'moment'

export default {
  name: 'LessonsCard',

  components: {
    rowLessons,
  },

  props: {
    weekday: {
      type: Number,
      required: true,
    },
    times: {
      type: Array,
      required: true,
    },
    isTeachers: {
      type: Boolean,
      default: false
    },
    isCabinets: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('navigations', ['date', 'startDate', 'endDate']),
    ...mapGetters('bootstrap', ['averageDuration']),

    currentDate() {
      return moment(this.date).isoWeekday(this.weekday)
    },

    isToday() {
      return moment(this.date).isoWeekday(this.weekday).format('DD.MM.YYYY') === moment().format('DD.MM.YYYY')
    },

    weekDayName() {
      const name = this.currentDate.format('dddd')

      return name[0].toUpperCase() + name.slice(1)
    },

    lessonsGrouped() {
      return _(this.lessons)
        .groupBy((x) => x.startTimeMin)
        .map((lessons) => lessons)
        .orderBy((lessons) => lessons[0].startTimeMin)
        .value()
    },

    hasLessons() {
      return this.times.some((x) => x.lessons.length)
    },

    currentMinutes() {
      const mmt = moment()
      const mmtMidnight = mmt.clone().startOf('day')

      return mmt.diff(mmtMidnight, 'minutes')
    }
  },

  methods: {
    hasWindow(l1, l2) {
      return (l2.startTimeMin - l1.endTimeMin) > this.averageDuration
    },

    windowDuration(l1, l2) {
      const duration = l2.startTimeMin - l1.endTimeMin

      if (!duration) return ''

      const hours = Math.floor(duration / 60);
      const minutes = duration % 60
      let result = 'Окно: '

      if (hours) result += `${hours} ${this.$options.filters.plural(hours, 'час', 'часа', 'часов')} `
      if (minutes) result += `${minutes} мин.`

      return result.trim()
    },

    hasCurrentTime(row) {
      return this.isToday && row.startTimeMin < this.currentMinutes && this.currentMinutes < row.endTimeMin
    }
  }
}
</script>

<style lang="sass" scoped>

.weekday-name
  text-align: center
  color: #0776cb
  font-size: 18px

.table-lessons
  font-size: 12px
  border-collapse: collapse
  width: 100%

  th
    padding: 5px
    border-bottom: 2px solid #838383

  td
    padding: 5px

  tr:not(:last-child)
    td,
    ::v-deep .td
      border-bottom: 1px solid #c1c1c1

  .time
    max-width: 44px
    width: 44px

    &:not(th)
      border-right: 1px solid #c1c1c1

.v-card
  padding: 10px 10px 20px

.caption-lessons
  text-align: left

.window
  color: gray

  td
    height: 40px
    line-height: 40px

.today
  display: inline-block
  margin-left: 5px

.current-time
  font-weight: bold
</style>
